import List from "./List";
import {RouterProps} from "../../../../RouterProps";
import {Route, Routes} from "react-router-dom";
import Detail from "./Detail";
import Post from "./Post";
import Edit from "./Edit";

export default function PreemptionRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:contentQueryPopularPreemptionId'} element={<Detail {...props} />} />
            <Route path={'/:contentQueryPopularPreemptionId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}